import DataTypeFunctions from "@viz-ui/services/metrics/dataTypeFunctions";

angular
  .module("acl.visualizer.dataTypeFunctions", ["acl.visualizer.model.metric"])
  .service("DataTypeFunctions", () => DataTypeFunctions);
